import { useState, useEffect } from "react";
import { G, D, D2, D3, BR, T2, TX } from "../theme";
import { getCl } from "../utils";
import { supabase, criarPerfil } from "../supabase";

export default function AdminPanel(props) {
  var [coaches, setCoaches] = useState([]);
  var [respostas, setRespostas] = useState([]);
  var [carregando, setCarregando] = useState(true);
  var [aba, setAba] = useState("coaches");
  var [aNome, setANome] = useState("");
  var [aEmail, setAEmail] = useState("");
  var [aSenha, setASenha] = useState("");
  var [aMsg, setAMsg] = useState("");

  var inp = {width:"100%",background:"#1a1a1a",border:"1px solid "+BR,borderRadius:8,padding:"11px 14px",color:TX,fontSize:13,boxSizing:"border-box",outline:"none"};

  useEffect(function(){
    async function carregar() {
      var { data: cs } = await supabase.from("profiles").select("*").eq("role","coach").order("created_at", {ascending:false});
      var { data: rs } = await supabase.from("avaliacoes_respostas").select("*").order("created_at", {ascending:false});
      setCoaches(cs || []);
      setRespostas(rs || []);
      setCarregando(false);
    }
    carregar();
  }, []); // eslint-disable-line

  var totalDiag = respostas.length;
  var mediaPlat = respostas.length ? Math.round(respostas.reduce(function(a,r){ return a+r.media_geral; },0)/respostas.length*10)/10 : 0;
  var coachMaisAtivo = coaches.map(function(c){
    return {nome:c.nome, total:respostas.filter(function(r){ return r.professor_id===c.id; }).length};
  }).sort(function(a,b){ return b.total-a.total; })[0];

  return (
    <div style={{backgroundColor:D,minHeight:"100vh",color:TX,fontFamily:"Arial,sans-serif"}}>
      <div style={{borderBottom:"1px solid "+BR,padding:"1rem 1.5rem",display:"flex",justifyContent:"space-between",alignItems:"center",background:D2}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{fontSize:11,color:G,letterSpacing:3,fontWeight:600}}>RMS</div>
          <div style={{fontSize:16,fontWeight:700,color:"#fff"}}>Painel Admin</div>
        </div>
        <button onClick={props.onLogout} style={{background:"none",border:"1px solid "+BR,borderRadius:7,padding:"7px 14px",color:T2,fontSize:12,cursor:"pointer"}}>Sair</button>
      </div>

      <div style={{padding:"1.5rem",maxWidth:900,margin:"0 auto"}}>
        {carregando ? (
          <div style={{textAlign:"center",padding:"4rem",color:T2}}>Carregando...</div>
        ) : (
          <>
            {/* Stats globais */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,marginBottom:24}}>
              {[
                {label:"Total de coaches",value:coaches.length,icon:"👨‍⚕️"},
                {label:"Total de diagnósticos",value:totalDiag,icon:"📊"},
                {label:"Média da plataforma",value:mediaPlat?mediaPlat+"/10":"—",icon:"⭐"},
              ].map(function(s){ return (
                <div key={s.label} style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.25rem"}}>
                  <div style={{fontSize:24,marginBottom:8}}>{s.icon}</div>
                  <div style={{fontSize:28,fontWeight:700,color:G}}>{s.value}</div>
                  <div style={{fontSize:12,color:T2,marginTop:4}}>{s.label}</div>
                </div>
              );})}
            </div>

            {coachMaisAtivo && coachMaisAtivo.total > 0 && (
              <div style={{background:D3,border:"1px solid "+G+"44",borderRadius:12,padding:"1rem 1.25rem",marginBottom:24,display:"flex",alignItems:"center",gap:12}}>
                <div style={{fontSize:24}}>🏆</div>
                <div>
                  <div style={{fontSize:12,color:T2}}>Coach mais ativo</div>
                  <div style={{fontWeight:600,color:G}}>{coachMaisAtivo.nome} — {coachMaisAtivo.total} diagnósticos</div>
                </div>
              </div>
            )}

            {/* Abas */}
            <div style={{display:"flex",gap:4,marginBottom:20,background:D3,border:"1px solid "+BR,borderRadius:10,padding:4}}>
              {[{id:"coaches",label:"👨‍⚕️ Coaches"},{id:"diagnosticos",label:"📋 Diagnósticos"},{id:"criar",label:"➕ Criar coach"}].map(function(t){
                return (
                  <button key={t.id} onClick={function(){ setAba(t.id); }}
                    style={{flex:1,padding:"9px 0",borderRadius:8,border:"none",cursor:"pointer",fontSize:13,fontWeight:500,
                      background:aba===t.id?G+"22":"none",color:aba===t.id?G:T2}}>
                    {t.label}
                  </button>
                );
              })}
            </div>

            {/* Lista de coaches */}
            {aba==="coaches" && (
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {coaches.length===0 && <div style={{textAlign:"center",padding:"2rem",color:T2,background:D3,border:"1px solid "+BR,borderRadius:12}}>Nenhum coach registado.</div>}
                {coaches.map(function(c){
                  var totalC = respostas.filter(function(r){ return r.professor_id===c.id; }).length;
                  var mediaC = totalC ? Math.round(respostas.filter(function(r){ return r.professor_id===c.id; }).reduce(function(a,r){ return a+r.media_geral; },0)/totalC*10)/10 : 0;
                  return (
                    <div key={c.id} style={{background:D3,border:"1px solid "+BR,borderRadius:12,padding:"1rem 1.25rem",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
                      <div style={{display:"flex",alignItems:"center",gap:12}}>
                        <div style={{width:40,height:40,borderRadius:"50%",background:G+"33",border:"1px solid "+G,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,color:G,fontSize:14,overflow:"hidden"}}>
                          {c.foto_url ? <img src={c.foto_url} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/> : (c.avatar||"?")}
                        </div>
                        <div>
                          <div style={{fontWeight:600,fontSize:14,color:"#fff"}}>{c.nome||"Sem nome"}</div>
                          <div style={{fontSize:12,color:T2}}>{c.email} · {c.especialidade||"Profissional"}</div>
                          <div style={{fontSize:11,color:T2,marginTop:2}}>Registado em {c.created_at?new Date(c.created_at).toLocaleDateString("pt-BR"):""}</div>
                        </div>
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:16}}>
                        <div style={{textAlign:"center"}}>
                          <div style={{fontSize:20,fontWeight:700,color:G}}>{totalC}</div>
                          <div style={{fontSize:11,color:T2}}>diagnósticos</div>
                        </div>
                        {totalC > 0 && (
                          <div style={{textAlign:"center"}}>
                            <div style={{fontSize:20,fontWeight:700,color:"#4CAF50"}}>{mediaC}</div>
                            <div style={{fontSize:11,color:T2}}>média</div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Todos os diagnósticos */}
            {aba==="diagnosticos" && (
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {respostas.length===0 && <div style={{textAlign:"center",padding:"2rem",color:T2,background:D3,border:"1px solid "+BR,borderRadius:12}}>Nenhum diagnóstico ainda.</div>}
                {respostas.map(function(r,i){
                  var cl = getCl(r.media_geral);
                  var coach = coaches.find(function(c){ return c.id===r.professor_id; });
                  return (
                    <div key={r.id||i} style={{background:D3,border:"1px solid "+BR,borderRadius:12,padding:"1rem 1.25rem",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
                      <div>
                        <div style={{fontWeight:600,fontSize:14,color:"#fff"}}>{r.aluno_nome}</div>
                        <div style={{fontSize:12,color:T2}}>Coach: <span style={{color:G}}>{coach?coach.nome:"—"}</span> · {new Date(r.created_at).toLocaleDateString("pt-BR")}</div>
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:12}}>
                        <div style={{fontSize:20,fontWeight:700,color:cl.cor}}>{r.media_geral}</div>
                        <span style={{fontSize:11,padding:"3px 10px",borderRadius:20,background:cl.bg,color:cl.cor,fontWeight:600}}>{cl.label}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Criar coach */}
            {aba==="criar" && (
              <div style={{background:D3,border:"1px solid "+BR,borderRadius:12,padding:"1.25rem"}}>
                <div style={{fontSize:13,fontWeight:600,color:G,marginBottom:14}}>Criar profissional</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
                  <div><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>Nome</label><input value={aNome} onChange={function(e){ setANome(e.target.value); }} placeholder="Dr. Nome" style={inp}/></div>
                  <div><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>E-mail</label><input value={aEmail} onChange={function(e){ setAEmail(e.target.value); }} placeholder="email@ex.com" style={inp}/></div>
                </div>
                <div style={{marginBottom:12}}><label style={{fontSize:11,color:T2,display:"block",marginBottom:5}}>Senha</label><input type="password" value={aSenha} onChange={function(e){ setASenha(e.target.value); }} style={{...inp,maxWidth:"50%"}}/></div>
                {aMsg && <div style={{fontSize:12,color:aMsg.startsWith("✓")?"#4CAF50":"#E53935",marginBottom:10}}>{aMsg}</div>}
                <button onClick={async function(){
                  if (!aNome||!aEmail||!aSenha) { setAMsg("Preencha todos os campos."); return; }
                  setAMsg("A criar...");
                  var result = await criarPerfil(aNome, aEmail, aSenha);
                  if (result.error) { setAMsg("Erro: " + result.error); return; }
                  setAMsg("✓ Profissional criado com sucesso!"); setANome(""); setAEmail(""); setASenha("");
                  setTimeout(function(){ setAMsg(""); }, 4000);
                }} style={{background:G,color:D,border:"none",borderRadius:8,padding:"10px 20px",fontWeight:600,fontSize:13,cursor:"pointer"}}>Criar</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
